import {DigitalRevisionMenuItem} from '../interfaces/digital-revision-menu-item';
import {ProxyTypeEnum} from '../interfaces/proxy-type-enum';
import {MenuItemTypeEnum} from '../interfaces/menu-item-type-enum';
import { MenuItemModel } from '../models/menu-item.model';

const sharedMenuBar: MenuItemModel[] = [
  {
    Text: 'Home',
    ImagePath: '/assets/images/landing/home.png',
    DestinationPage: '',
  },
  {
    Text: 'Quick Quiz',
    ImagePath: '/assets/images/landing/quick-quizzes.png',
    DestinationPage: 'Quick-Quiz',
  },
  {
    Text: 'Mistakes Quiz',
    ImagePath: '/assets/images/landing/your-mistakes-quiz.png',
    DestinationPage: 'Mistakes-Quiz',
    MenuType: MenuItemTypeEnum.MistakesQuiz,
  },
  {
    Text: 'Summary Test',
    ImagePath: '/assets/images/landing/revision-summary-test.png',
    DestinationPage: 'Revision-Summary-Test',
  },
  {
    Text: 'Video Solutions',
    ImagePath: '/assets/images/landing/graph.png',
    DestinationPage: 'video-solutions',
  }
];

export const HomePageMenuItems: DigitalRevisionMenuItem[] = [
  {
    MenuItemType: MenuItemTypeEnum.QuickQuiz,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'Take a Quick Quiz',
    ButtonURL: 'quick-quiz',

    MixedOnlineTests: [
      {
        // TODO: verify URL
        MixedOnlineTestUrl: '_revisionhub_opc/MHR141/MHR141_QuickQuiz',
        Proxy: ProxyTypeEnum.CFProxy,
      },
    ],
    HasData: true,
    HeadingText: 'Quick Quizzes',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText:
      '<p>Test yourself with quizzes covering every topic.  On your marks, get set… quiz!</p>' +
      '\n' +
      '<p>Questions answered: <strong>[[variable1]]</strong></p>\n' +
      '\n' +
      '<p>Last quiz score: <strong>[[variable2]]</strong></p>',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Questions on every topic',
    SwitcherCookieName: '',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: '',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: sharedMenuBar,
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },},
  {
    MenuItemType: MenuItemTypeEnum.MistakesQuiz,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'Go to Mistakes Quiz',
    ButtonURL: 'mistakes-quiz',

    MixedOnlineTests: [
      {
        MixedOnlineTestUrl: '_revisionhub_opc/MHR141/MHR141_Mistakes',
        Proxy: ProxyTypeEnum.CFProxy,
      },
    ],
    HasData: true,
    HeadingText: 'Your Mistakes Quiz',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText:
      '<p>The quick quiz questions you got wrong are here  -  have another go and conquer them once and for all!</p>' +
      '<p>Total questions stored: <strong>[[variable1]]</strong></p>\n' +
      '<p>Total questions answered: <strong>[[variable2]]</strong><br />\n',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Correct your wrong answers',
    SwitcherCookieName: '',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: '',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: sharedMenuBar,
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },},
  {
    MenuItemType: MenuItemTypeEnum.RevisionSummary,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'Go to Revision Summary Tests',
    ButtonURL: 'revision-summary-test',

    MixedOnlineTests: [
      {
        // TODO: verify URL
        MixedOnlineTestUrl: '_revisionhub_opc/MHR141/MHR141_RevisionSummary',
        Proxy: ProxyTypeEnum.CFProxy,
      },
    ],
    HasData: true,
    HeadingText: 'Revision Summary Test',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText:
      '<p>See how well you understand each section. Mark your answers with our examples.</p>' +
      '<p>Questions answered: <strong>[[variable1]]</strong></p>\n' +
      '<p>Questions marked <img src="assets/images/smiley-face-green.png" width="30" height="30" style="vertical-align:middle;" /> : <strong>[[variable2]]</strong><br />\n',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'In-depth written questions',
    SwitcherCookieName: '',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: '',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: sharedMenuBar,
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },},
  {
    MenuItemType: MenuItemTypeEnum.VideoSolutions,
    IsFreeSample: false,
    IconPath: '/assets/images/landing/graph.png',
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'Watch solutions',
    ButtonURL: 'worked-answer-videos',
    MixedOnlineTests: [],

    HasData: false,
    HeadingText: 'Video Solutions',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText: '<p>Learn how to answer the exam-style questions in your book.</p>',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Step-by-step exam answers',
    SwitcherCookieName: '',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Title: 'Video Solutions',
        Intro: '<p>CGP\'s friendly experts are here to walk you through some of the exam-style questions in your book  -  have a go at the questions first and use these videos if you need a bit of extra help.</p>',
        LeftSections: [
          {
            Header: 'Section One  -  Number',
            Subcategories: [
              { Name: 'Finding Prime Factorisations', ShortName: 'finding-prime-factorisations', Link: 'https://www.youtube.com/embed/_iuIq062n64?rel=0&modestbranding=1' },
              { Name: 'Finding the Lowest Common Multiple', ShortName: 'finding-the-lowest-common-multiple', Link: 'https://www.youtube.com/embed/FYdlj39HktA?rel=0&modestbranding=1' },
              { Name: 'Fraction Problems', ShortName: 'fraction-problems', Link: 'https://www.youtube.com/embed/GaCqLPbB_s8?rel=0&modestbranding=1' },
              { Name: 'Turning Recurring Decimals into Fractions', ShortName: 'turning-recurring-decimals-into-fractions', Link: 'https://www.youtube.com/embed/l2z2X7eQQtU?rel=0&modestbranding=1' },
              { Name: 'Estimating', ShortName: 'estimating', Link: 'https://www.youtube.com/embed/fFhvIf4TreM?rel=0&modestbranding=1' },
              { Name: 'Calculating with Bounds', ShortName: 'calculating-with-bounds', Link: 'https://www.youtube.com/embed/b8JoNaeHrB8?rel=0&modestbranding=1' },
              { Name: 'Standard Form', ShortName: 'standard-form', Link: 'https://www.youtube.com/embed/ZZlmQnE5Cco?rel=0&modestbranding=1' },
            ],
          },
          {
            Header: 'Section Two  -  Algebra',
            Subcategories: [
              { Name: 'Working with Powers', ShortName: 'working-with-powers', Link: 'https://www.youtube.com/embed/F9a5mZTkZno?rel=0&modestbranding=1' },
              { Name: 'Multipliying Out Brackets', ShortName: 'multipliying-out-brackets', Link: 'https://www.youtube.com/embed/8H7Jkg4tasQ?rel=0&modestbranding=1' },
              { Name: 'Rationalising the Denominator', ShortName: 'rationalising-the-denominator', Link: 'https://www.youtube.com/embed/4i0JvIvcTwY?rel=0&modestbranding=1' },
              { Name: 'Solving Equations', ShortName: 'solving-equations', Link: 'https://www.youtube.com/embed/w3wYexmcKjI?rel=0&modestbranding=1' },
              { Name: 'Rearranging Formulas', ShortName: 'rearranging-formulas', Link: 'https://www.youtube.com/embed/PEvbrP6MAJg?rel=0&modestbranding=1' },
              { Name: 'Factorising Quadratics', ShortName: 'factorising-quadratics', Link: 'https://www.youtube.com/embed/75eqQjsicQU?rel=0&modestbranding=1' },
              { Name: 'Completing the Square', ShortName: 'completing-the-square', Link: 'https://www.youtube.com/embed/VP1zCHzgcd4?rel=0&modestbranding=1' },
              { Name: 'Algebraic Fractions', ShortName: 'algebraic-fractions', Link: 'https://www.youtube.com/embed/vB6IJYry6O4?rel=0&modestbranding=1' },
              { Name: 'Solving Sequence Problems', ShortName: 'solving-sequence-problems', Link: 'https://www.youtube.com/embed/eNjIW0Ma4Wc?rel=0&modestbranding=1' },
              { Name: 'Inequalities', ShortName: 'inequalities', Link: 'https://www.youtube.com/embed/SIizlU9gc-A?rel=0&modestbranding=1' },
              { Name: 'Graphical Inequalities', ShortName: 'graphical-inequalities', Link: 'https://www.youtube.com/embed/XF35-pgqPFs?rel=0&modestbranding=1' },
              { Name: 'Wordy Simultaneous Equations', ShortName: 'wordy-simultaneous-equations', Link: 'https://www.youtube.com/embed/mEA0d3fSryk?rel=0&modestbranding=1' },
              { Name: 'Solving Simultaneous Equations', ShortName: 'solving-simultaneous-equations', Link: 'https://www.youtube.com/embed/VZdYN_24QM8?rel=0&modestbranding=1' },
              { Name: 'Proof', ShortName: 'proof', Link: 'https://www.youtube.com/embed/PWxCj-EGrIQ?rel=0&modestbranding=1' },
            ],
          },
          {
            Header: 'Section Three  -  Graphs',
            Subcategories: [
              { Name: 'Finding the Equation of a Straight Line', ShortName: 'finding-the-equation-of-a-straight-line', Link: 'https://www.youtube.com/embed/zJhzD_vthRY?rel=0&modestbranding=1' },
              { Name: 'Coordinates and Ratio', ShortName: 'coordinates-and-ratio', Link: 'https://www.youtube.com/embed/f6NXQNI5hcg?rel=0&modestbranding=1' },
              { Name: 'Finding the Equations of Parallel Lines', ShortName: 'finding-the-equations-of-parallel-lines', Link: 'https://www.youtube.com/embed/rbiV0AkrKm8?rel=0&modestbranding=1' },
              { Name: 'Circle Graphs', ShortName: 'circle-graphs', Link: 'https://www.youtube.com/embed/fguQMQXSPyo?rel=0&modestbranding=1' },
              { Name: 'Exponential Graphs', ShortName: 'exponential-graphs', Link: 'https://www.youtube.com/embed/CW_fsDTffys?rel=0&modestbranding=1' },
              { Name: 'Solving Equations Using Graphs', ShortName: 'solving-equations-using-graphs', Link: 'https://www.youtube.com/embed/EXvPIg366l4?rel=0&modestbranding=1' },
              { Name: 'Using Distance-Time Graphs', ShortName: 'using-distance-time-graphs', Link: 'https://www.youtube.com/embed/sz3ubmzH0zo?rel=0&modestbranding=1' },
              { Name: 'Gradients of Real-Life Graphs', ShortName: 'gradients-of-real-life-graphs', Link: 'https://www.youtube.com/embed/-zkwuyx84UI?rel=0&modestbranding=1' },
            ],
          },
        ],
        RightSections: [
          {
            Header: 'Section Four  -  Ratio, Proportion and Rates of Change',
            Subcategories: [
              { Name: 'Ratios', ShortName: 'ratios', Link: 'https://www.youtube.com/embed/hUKN5470PKQ?rel=0&modestbranding=1' },
              { Name: 'Direct Proportion', ShortName: 'direct-proportion', Link: 'https://www.youtube.com/embed/ayyi7IoMf4o?rel=0&modestbranding=1' },
              { Name: 'Percentages - Finding the Original Value', ShortName: 'percentages-finding-the-original-value', Link: 'https://www.youtube.com/embed/iKBI0Zl992Y?rel=0&modestbranding=1' },
              { Name: 'Compound Interest', ShortName: 'compound-interest', Link: 'https://www.youtube.com/embed/YAChcgPGX8E?rel=0&modestbranding=1' },
              { Name: 'Density', ShortName: 'density', Link: 'https://www.youtube.com/embed/e_9ZkgIYCz4?rel=0&modestbranding=1' },
            ],
          },
          {
            Header: 'Section Five  -  Geometry and Measures',
            Subcategories: [
              { Name: 'Angles and Parallel Lines', ShortName: 'angles-and-parallel-lines', Link: 'https://www.youtube.com/embed/JQJ7Ux5-Wx0?rel=0&modestbranding=1' },
              { Name: 'Finding Interior Angles in a Polygon', ShortName: 'finding-interior-angles-in-a-polygon', Link: 'https://www.youtube.com/embed/BjYzeBZc-DU?rel=0&modestbranding=1' },
              { Name: 'Circle Theorems', ShortName: 'circle-theorems', Link: 'https://www.youtube.com/embed/47jtc16HM3U?rel=0&modestbranding=1' },
              { Name: 'Similar Shapes', ShortName: 'similar-shapes', Link: 'https://www.youtube.com/embed/D9Qsd2XHWZg?rel=0&modestbranding=1' },
              { Name: 'Enlargements', ShortName: 'enlargements', Link: 'https://www.youtube.com/embed/oT2lFCu4ZFI?rel=0&modestbranding=1' },
              { Name: 'Sectors, Segments and Arcs', ShortName: 'sectors-segments-and-arcs', Link: 'https://www.youtube.com/embed/BeWKUgOB0xY?rel=0&modestbranding=1' },
              { Name: 'Surface Area', ShortName: 'surface-area', Link: 'https://www.youtube.com/embed/dJzsyCUX3qA?rel=0&modestbranding=1' },
              { Name: 'Volumes of 3D Shapes', ShortName: 'volumes-of-3d-shapes', Link: 'https://www.youtube.com/embed/XwBtaXvBJEM?rel=0&modestbranding=1' },
              { Name: 'Triangle Construction', ShortName: 'triangle-construction', Link: 'https://www.youtube.com/embed/vlGBM4is22A?rel=0&modestbranding=1' },
              { Name: 'Loci', ShortName: 'loci', Link: 'https://www.youtube.com/embed/Nq5l_mLHD4M?rel=0&modestbranding=1' },
              { Name: 'Bearings', ShortName: 'bearings', Link: 'https://www.youtube.com/embed/L-jVmitnMZU?rel=0&modestbranding=1' },
            ],
          },
          {
            Header: 'Section Six  -  Pythagoras and Trigonometry',
            Subcategories: [
              { Name: 'Pythagoras\' Theorem', ShortName: 'pythagoras%27-theorem', Link: 'https://www.youtube.com/embed/S0WI-k2h2nQ?rel=0&modestbranding=1' },
              { Name: 'Trigonometry', ShortName: 'trigonometry', Link: 'https://www.youtube.com/embed/B9QCSPyHjdg?rel=0&modestbranding=1' },
              { Name: 'Trigonometry - Common Values', ShortName: 'trigonometry-common-values', Link: 'https://www.youtube.com/embed/MT8oK0pNHXc?rel=0&modestbranding=1' },
              { Name: 'The Sine and Cosine Rules', ShortName: 'the-sine-and-cosine-rules', Link: 'https://www.youtube.com/embed/OsqETT6W_Eg?rel=0&modestbranding=1' },
              { Name: '3D Trigonometry', ShortName: '3d-trigonometry', Link: 'https://www.youtube.com/embed/JsAayXd1V5c?rel=0&modestbranding=1' },
              { Name: 'Vectors and Ratios', ShortName: 'vectors-and-ratios', Link: 'https://www.youtube.com/embed/ACbZ2QSioGo?rel=0&modestbranding=1' },
            ],
          },
          {
            Header: 'Section Seven  -  Probability and Statistics',
            Subcategories: [
              { Name: 'Probability - Counting Outcomes', ShortName: 'probability-counting-outcomes', Link: 'https://www.youtube.com/embed/Ow2TjFUjQ7U?rel=0&modestbranding=1' },
              { Name: 'Probability Experiments', ShortName: 'probability-experiments', Link: 'https://www.youtube.com/embed/vYvkKkdbOH4?rel=0&modestbranding=1' },
              { Name: 'The OR Rule', ShortName: 'the-or-rule', Link: 'https://www.youtube.com/embed/-xTsjXHSyTY?rel=0&modestbranding=1' },
              { Name: 'Conditional Probability', ShortName: 'conditional-probability', Link: 'https://www.youtube.com/embed/Y-VsdJEh0do?rel=0&modestbranding=1' },
              { Name: 'Venn Diagrams', ShortName: 'venn-diagrams', Link: 'https://www.youtube.com/embed/3lUb3YrYYU4?rel=0&modestbranding=1' },
              { Name: 'Mean, Median, Mode and Range', ShortName: 'mean-median-mode-and-range', Link: 'https://www.youtube.com/embed/xFbZBJZK8PE?rel=0&modestbranding=1' },
              { Name: 'Finding Averages from Frequency Tables', ShortName: 'finding-averages-from-frequency-tables', Link: 'https://www.youtube.com/embed/-wzFgvH2Jao?rel=0&modestbranding=1' },
              { Name: 'Box Plots', ShortName: 'box-plots', Link: 'https://www.youtube.com/embed/TimzpYZ2uTs?rel=0&modestbranding=1' },
              { Name: 'Histograms', ShortName: 'histograms', Link: 'https://www.youtube.com/embed/5Zxt31QICz8?rel=0&modestbranding=1' },
            ],
          },
        ],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: '',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: sharedMenuBar,
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },},
  {
    MenuItemType: MenuItemTypeEnum.VideoExplanations,
    IsFreeSample: false,
    IconPath: '/assets/images/landing/Tilted-Protractor.png',
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'Watch explanations',
    ButtonURL: 'content-videos',
    MixedOnlineTests: [],

    HasData: false,
    HeadingText: 'Video Explanations',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText: '<p>Our experts break down tricky concepts for you.</p>',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Get to grips with tricky concepts',
    SwitcherCookieName: '',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Title: 'Video Explanations',
        Intro: '<p>These handy videos explain some of the trickier concepts in your book. So grab your popcorn (or a pencil) and dig in!</p>',
        LeftSections: [
          {
            Header: 'Section One  -  Number',
            Subcategories: [
              { Name: 'LCM and HCF with Prime Factors', ShortName: 'lcm-and-hcf-with-prime-factors', Link: 'https://www.youtube.com/embed/9FmxDTSUXhs?rel=0&modestbranding=1' },
              { Name: 'Recurring Decimals', ShortName: 'recurring-decimals', Link: 'https://www.youtube.com/embed/V5FzX7VB0zM?rel=0&modestbranding=1' },
              { Name: 'Upper and Lower Bounds', ShortName: 'upper-and-lower-bounds', Link: 'https://www.youtube.com/embed/EdIdlBJIS0c?rel=0&modestbranding=1' },
              { Name: 'Standard Form', ShortName: 'standard-form', Link: 'https://www.youtube.com/embed/tPd4McO11Mg?rel=0&modestbranding=1' },
            ],
          },
          {
            Header: 'Section Two  -  Algebra',
            Subcategories: [
              { Name: 'Difference of Two Squares', ShortName: 'difference-of-two-squares', Link: 'https://www.youtube.com/embed/HO4yONyaajU?rel=0&modestbranding=1' },
              { Name: 'Surds', ShortName: 'surds', Link: 'https://www.youtube.com/embed/9p7CfKW6ido?rel=0&modestbranding=1' },
              { Name: 'The Quadratic Formula Song', ShortName: 'the-quadratic-formula-song', Link: 'https://www.youtube.com/embed/PE3JLf28N8I?rel=0&modestbranding=1' },
              { Name: 'Quadratic Sequences', ShortName: 'quadratic-sequences', Link: 'https://www.youtube.com/embed/LQ2HW8udw8c?rel=0&modestbranding=1' },
              { Name: 'Quadratic Inequalities', ShortName: 'quadratic-inequalities', Link: 'https://www.youtube.com/embed/HkeTdLbX2yM?rel=0&modestbranding=1' },
              { Name: 'Graphing Inequalities', ShortName: 'graphing-inequalities', Link: 'https://www.youtube.com/embed/iD_rjFgV5mQ?rel=0&modestbranding=1' },
              { Name: 'Proof', ShortName: 'proof', Link: 'https://www.youtube.com/embed/ap2MsMcAWVI?rel=0&modestbranding=1' },
              { Name: 'Composite Functions', ShortName: 'composite-functions', Link: 'https://www.youtube.com/embed/vJwc5pWldM8?rel=0&modestbranding=1' },
            ],
          },
          {
            Header: 'Section Three  -  Graphs',
            Subcategories: [
              { Name: 'Parallel and Perpendicular Lines', ShortName: 'parallel-and-perpendicular-lines', Link: 'https://www.youtube.com/embed/F6gouB65q6w?rel=0&modestbranding=1' },
              { Name: 'Harder Graphs to Learn', ShortName: 'harder-graphs-to-learn', Link: 'https://www.youtube.com/embed/Qfubx840liY?rel=0&modestbranding=1' },
              { Name: 'Trig Graphs', ShortName: 'trig-graphs', Link: 'https://www.youtube.com/embed/ln4f6ZT5E7k?rel=0&modestbranding=1' },
              { Name: 'Graph Transformations', ShortName: 'graph-transformations', Link: 'https://www.youtube.com/embed/XPWjNPhNoNw?rel=0&modestbranding=1' },
              { Name: 'Velocity-Time Graphs', ShortName: 'velocity-time-graphs', Link: 'https://www.youtube.com/embed/3jtAMHI8mQ0?rel=0&modestbranding=1' },
            ],
          },
          {
            Header: 'Section Four  -  Ratio, Proportion and Rates of Change',
            Subcategories: [
              { Name: 'Dividing in a Given Ratio', ShortName: 'dividing-in-a-given-ratio', Link: 'https://www.youtube.com/embed/lPtExLhYhrM?rel=0&modestbranding=1' },
              { Name: 'Ratios and Simultaneous Equations', ShortName: 'ratios-and-simultaneous-equations', Link: 'https://www.youtube.com/embed/qeQXzom0wzs?rel=0&modestbranding=1' },
              { Name: 'Percentage Increase and Decrease', ShortName: 'percentage-increase-and-decrease', Link: 'https://www.youtube.com/embed/-7IX08OJG88?rel=0&modestbranding=1' },
              { Name: 'Compound Interest and Depreciation', ShortName: 'compound-interest-and-depreciation', Link: 'https://www.youtube.com/embed/z-gTLhAhQ5c?rel=0&modestbranding=1' },
              { Name: 'Converting Areas and Volumes', ShortName: 'converting-areas-and-volumes', Link: 'https://www.youtube.com/embed/TiJPcIhBPb8?rel=0&modestbranding=1' },
            ],
          },
        ],
        RightSections: [
          {
            Header: 'Section Five  -  Geometry and Measures',
            Subcategories: [
              { Name: 'Polygons - Interior and Exterior Angles', ShortName: 'polygons-interior-and-exterior-angles', Link: 'https://www.youtube.com/embed/viqrYx-bvKA?rel=0&modestbranding=1' },
              { Name: 'Circle Rules - Examples', ShortName: 'circle-rules-examples', Link: 'https://www.youtube.com/embed/uwCGeBT4ZWY?rel=0&modestbranding=1' },
              { Name: 'Enlargements - Fractional and Negative', ShortName: 'enlargements-fractional-and-negative', Link: 'https://www.youtube.com/embed/FB55NCXOp4M?rel=0&modestbranding=1' },
              { Name: 'Volume of Spheres, Pyramids and Cones', ShortName: 'volume-of-spheres-pyramids-and-cones', Link: 'https://www.youtube.com/embed/OFeRWhSotoE?rel=0&modestbranding=1' },
              { Name: 'Locus Problems', ShortName: 'locus-problems', Link: 'https://www.youtube.com/embed/MAv7t2_zeNI?rel=0&modestbranding=1' },
            ],
          },
          {
            Header: 'Section Six  -  Pythagoras and Trigonometry',
            Subcategories: [
              { Name: 'Pythagoras\' Theorem', ShortName: 'pythagoras%27-theorem', Link: 'https://www.youtube.com/embed/1NbcIjZfwic?rel=0&modestbranding=1' },
              { Name: 'Common Trig Values', ShortName: 'common-trig-values', Link: 'https://www.youtube.com/embed/A95pKhtz0lA?rel=0&modestbranding=1' },
              { Name: '3D Problems', ShortName: '3d-problems', Link: 'https://www.youtube.com/embed/90w2yHMH9QU?rel=0&modestbranding=1' },
              { Name: 'Vectors - Typical Questions', ShortName: 'vectors-typical-questions', Link: 'https://www.youtube.com/embed/SqgPxIkRbKQ?rel=0&modestbranding=1' },
            ],
          },
          {
            Header: 'Section Seven  -  Probability and Statistics',
            Subcategories: [
              { Name: 'Listing Outcomes', ShortName: 'listing-outcomes', Link: 'https://www.youtube.com/embed/f1gcPCu39Zw?rel=0&modestbranding=1' },
              { Name: 'The AND and OR Rules', ShortName: 'the-and-and-or-rules', Link: 'https://www.youtube.com/embed/744K26uONpk?rel=0&modestbranding=1' },
              { Name: 'Conditional Probability', ShortName: 'conditional-probability', Link: 'https://www.youtube.com/embed/J0_o_b-VmfM?rel=0&modestbranding=1' },
              { Name: 'Sampling and Bias', ShortName: 'sampling-and-bias', Link: 'https://www.youtube.com/embed/JEtJRXitcjs?rel=0&modestbranding=1' },
              { Name: 'Averages for Grouped Data', ShortName: 'averages-for-grouped-data', Link: 'https://www.youtube.com/embed/X8M_8tV6tho?rel=0&modestbranding=1' },
              { Name: 'Histograms', ShortName: 'histograms', Link: 'https://www.youtube.com/embed/dy1kl47_GuE?rel=0&modestbranding=1' },
            ],
          },
        ],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: '',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: sharedMenuBar,
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },},
  {
    MenuItemType: MenuItemTypeEnum.HowToRevise,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'Take a look',
    ButtonURL: 'how-to-revise',

    MixedOnlineTests: [],

    HasData: false,
    HeadingText: 'How to Revise',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText: '<p>We\'ve spilled all the secrets to help you get the most out of your book and CGP RevisionHub.</p>',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Revision tips and tricks',
    SwitcherCookieName: '',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: '',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: sharedMenuBar,
    HowToRevise: {
      // TODO: populate DisplayName, BookType, and AdditionalText for the How to Revise section
      DisplayName: 'GCSE Maths',
      BookType: 'Revision Guide',
      AdditionalText: '',
      RevisionStyle: 'maths',
    },},
  {
    MenuItemType: MenuItemTypeEnum.OnlineEdition,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'Go to Your Online Products',
    ButtonURL: '[[external_domain]]/bookspacedemo',

    MixedOnlineTests: [],

    HasData: false,
    HeadingText: 'Online Edition',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText: '<p>Use your book wherever you are with your Online Edition  -  yippee!</p>',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Read your e-Book here',
    SwitcherCookieName: '',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: '',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: sharedMenuBar,
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },},
  {
    MenuItemType: MenuItemTypeEnum.Extras,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'View Extras',
    ButtonURL: 'extras',

    MixedOnlineTests: [],

    HasData: false,
    HeadingText: 'Extra Useful Bits',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText: '<p>Printable worked answers, formula sheet and exam tips  -  it\'s all right here.</p>',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Other resources to download',
    SwitcherCookieName: '',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      // TODO: populate ContentMain with intro text and ContentRight with an image if needed
      HeaderText: 'Extra Useful Bits',
      ContentMain: '<p>Your printable worked answers, formula sheet and exam tips are all below. Take your pick!</p>\n'+
      '<p><a href="[[cloudfront_url]]/_revisionhub_opc/MHR141/PDFs/cgp-gcse-maths-exam-tips-and-tricks.pdf" target="_blank">Exam Tips and Tricks</a></p>\n'+
      '<p><a href="[[cloudfront_url]]/_revisionhub_opc/MHR141/PDFs/cgp-gcse-maths-higher-formula-sheet.pdf" target="_blank">Formula Sheet</a></p>\n'+
      '<p><a href="[[cloudfront_url]]/_revisionhub_opc/MHR141/PDFs/cgp-gcse-maths-higher-worked-answers-section-1.pdf" target="_blank">Section One - Worked Answers</a></p>\n'+
      '<p><a href="[[cloudfront_url]]/_revisionhub_opc/MHR141/PDFs/cgp-gcse-maths-higher-worked-answers-section-2.pdf" target="_blank">Section Two - Worked Answers</a></p>\n'+
      '<p><a href="[[cloudfront_url]]/_revisionhub_opc/MHR141/PDFs/cgp-gcse-maths-higher-worked-answers-section-3.pdf" target="_blank">Section Three - Worked Answers</a></p>\n'+
      '<p><a href="[[cloudfront_url]]/_revisionhub_opc/MHR141/PDFs/cgp-gcse-maths-higher-worked-answers-section-4.pdf" target="_blank">Section Four - Worked Answers</a></p>\n'+
      '<p><a href="[[cloudfront_url]]/_revisionhub_opc/MHR141/PDFs/cgp-gcse-maths-higher-worked-answers-section-5.pdf" target="_blank">Section Five - Worked Answers</a></p>\n'+
      '<p><a href="[[cloudfront_url]]/_revisionhub_opc/MHR141/PDFs/cgp-gcse-maths-higher-worked-answers-section-6.pdf" target="_blank">Section Six - Worked Answers</a></p>\n'+
      '<p><a href="[[cloudfront_url]]/_revisionhub_opc/MHR141/PDFs/cgp-gcse-maths-higher-worked-answers-section-7.pdf" target="_blank">Section Seven - Worked Answers</a></p>\n',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: '',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: sharedMenuBar,
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },},
  {
    MenuItemType: MenuItemTypeEnum.NeedHelp,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'Take a look',
    ButtonURL: '',

    MixedOnlineTests: [],

    HasData: false,
    HeadingText: 'Need some help?',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText: '<p>We can\'t explain the meaning of life, but we can explain how to use your RevisionHub pretty well.</p>',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Check out our FAQs',
    SwitcherCookieName: '',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      TagLine: 'We\'ve put together lots of helpful information on how to get the most out of your Revision Guide. And if you\'ve hit any snags, you\'ll find the answers you need here too.',
      Text:
        '<h2>Frequently Asked Questions</h2>\n' +
      '<h5>What is CGP RevisionHub?</h5>\n' +
      '<p>Great question! CGP RevisionHub is our online platform where you can find lots of helpful revision, all matched to your GCSE Maths books. Use the quizzes, videos and more to revise what you\'ve learned from your book and prepare for the exams.</p>\n' +
      '<h5>How do I access CGP RevisionHub?</h5>\n' +
      '<p>You can access CGP RevisionHub on your computer, tablet or phone. Just make sure your device can connect to the internet. Wearing a spinny propellor hat is not required, but it is cool though.</p>\n' +
      '<h5>How do I use CGP RevisionHub with my book?</h5>\n' +
      '<p>You\'ll notice lots of QR codes scattered throughout your book. Give them a scan and you\'ll automatically be taken to the relevant test, video or other revision thingy-ma-jig so you can go over what you\'ve learned!</p>\n' +
      '<h5>My CGP RevisionHub isn\'t working  —  what do I do?</h5>\n' +
      '<p>If you can\'t find the answer in these FAQs, it\'s time to contact our friendly Customer Services team. You could also ask your friendly neighbourhood psychic, but they will charge...</p>\n' +
      '<h5>Do I need an internet connection to use CGP RevisionHub?</h5>\n' +
      '<p>Yes, you do. But you can also download some handy PDF resources to use offline. Nice.</p>\n' +
      '<h5>If I log in on a different device, will all my progress be saved?</h5>\n' +
      '<p>Yep. Just log in on your computer, tablet or phone, and all your progress will be there waiting for you.</p>\n' +
      '<h5>What\'s the difference between the Quick Quizzes, Your Mistakes Quiz and Revision Summary Tests?</h5>\n' +
      '<p>Quick Quizzes are... well, quick! They\'re a speedy way to test all the maths on the course. Your Mistakes Quiz tests you on all the questions you got wrong in your Quick Quizzes. Revision Summary Tests include more challenging questions  -  mark them yourself using our example answers.</p>\n' +
      '<h5>Can I clear my progress so far in CGP RevisionHub and start again?</h5>\n' +
      '<p>There are no takie-backsies in CGP RevisionHub, so you can\'t clear your results and start again. But, you can have another go at any of the quizzes and they\'ll update to show your latest scores. Keep going, we believe in you!</p>\n' +
      '<h5>Can I share my test results with other people?</h5>\n' +
      '<p>You can\'t share results directly via CGP RevisionHub, but there are other means… Carrier pigeons and smoke signals are both great options. Or you could just tell them, but where\'s the fun in that?</p>\n' +
      '<h5>What happens when I\'ve answered all the questions?</h5>\n' +
      '<p>Ah, one of life\'s greatest questions  —  what next? We\'d recommend that you keep practising right up until your exams.</p>\n' +
      '<h5>Will I always have access to CGP RevisionHub?</h5>\n' +
      '<p>Once you activate the code in the front of your book, you\'ll have access for three years. And they\'ll be three whole years of bliss, we promise.</p>\n',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: '',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: sharedMenuBar,
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },},
  {
    MenuItemType: MenuItemTypeEnum.MoreFromCGP,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'See more CGP Revision',
    ButtonURL: '[[external_domain]]/secondary-books/gcse',

    MixedOnlineTests: [],

    HasData: false,
    HeadingText: 'More from CGP',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText: '<p>There\'s plenty more revision where this came from! Take a look at some of our other revision books.</p>',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Everything you need for revision!',
    SwitcherCookieName: '',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: '',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: sharedMenuBar,
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },}
];